import { render, staticRenderFns } from "./BoxOffices.vue?vue&type=template&id=98bedb80&"
import script from "./BoxOffices.vue?vue&type=script&lang=js&"
export * from "./BoxOffices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports